<script>
/**
 * @overview 七牛上传组件 - 音频预览
 *
 * @author huojinzhao
 */

export default {
  name: "AppQiniuPreviewAudio",

  props: {
    src: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    playing: false,
  }),

  watch: {
    playing(value) {
      value
        ? this.$refs.audio.play()
        : this.$refs.audio.pause();
    },
  },

  methods: {
    preview() {
      this.playing = !this.playing;
    },
  },
};
</script>

<template>
  <span class="app-qiniu__preview-audio">
    <!-- eslint-disable-next-line -->
    <audio ref="audio" v-show="false" :src="src" />

    <i class="iconfont icon-music" />
  </span>
</template>

<style lang="postcss">
.app-qiniu__preview-audio {
  display: flex;
  justify-content: center;
  align-items: center;
}

.app-qiniu__preview-audio > .iconfont {
  font-size: 50px;
  color: var(--font-color-secondary);
}
</style>
